export interface IligaNews {
    id: number,
    title?: string,
    content?: string,
    imagePath?: string,
    addDate?: string,
    publicDate?: string
    publicDateConverted?: string
}

export class ligaNews implements IligaNews {
    public publicDateConverted = '';
    
    constructor(
        public id: number,
        public title?: string,
        public content?: string,
        public imagePath?: string,
        public addDate?: string,
        public publicDate?: string
        ) {}
}
  